import { orderBy } from "lodash";
import { Item__Atividades__insumos, Item__AtvAdjuvantes, Item__AtvCalcario, Item__AtvFertilizantes, Item__AtvInoculante, Item__AtvProdutos, Item__AtvVariedadeHibrido, Item__UnidadeMedida, typeTecnologia } from "../../../../../../../../../services/atividades/GET";
import { errorAlert } from "../../../../../../../../../utils/alert";

/**Tipos de uso, usado no cadastro de insumo */
export const dummy_tipos_uso = [
    { cod: 5, nome: 'Adjuvantes' },
    { cod: 9, nome: 'Biológico' },
    { cod: 6, nome: 'Calcário' },
    { cod: 1, nome: 'Defensivos em geral' },
    { cod: 3, nome: 'Fertilizante' },
    { cod: 8, nome: 'Inoculante' },
    { cod: 4, nome: 'Tratamento Semente' },
    { cod: 2, nome: 'Semente (Variedade/Híbrido)' },
    // {cod: 7, nome: 'Gesso'}, //ainda não foi solicitado sua inclusão, mas o Beto já faz por garantia 21/11/25
];

// export const dummy_tipos_de_insumos = [
//     {cod: 1, nome:'Insumo'}, // produto 
//     {cod: 2, nome:'Fertilizante'}, 
//     {cod: 3, nome:'Variedade/Híbrido'}
// ];

type typeValidar = {
    cod_tipo_uso: number,
    setError_tipo_uso: React.Dispatch<React.SetStateAction<string>>,
    cod_produto: number,
    setError_produto: React.Dispatch<React.SetStateAction<string>>,
    cod_fertilizante: number,
    setError_fertilizante: React.Dispatch<React.SetStateAction<string>>,
    cod_variedade_hibrido: number,
    setError_variedade_hibrido: React.Dispatch<React.SetStateAction<string>>,
    cod_tecnologia: number,
    setError_tecnologia: React.Dispatch<React.SetStateAction<string>>,
    area: string,
    setError_area: React.Dispatch<React.SetStateAction<string>>,
    dosagem: string,
    setError_dosagem: React.Dispatch<React.SetStateAction<string>>,
    quantidade: string,
    setError_quantidade: React.Dispatch<React.SetStateAction<string>>,
    cod_medida: number,
    setError_unidade_medida: React.Dispatch<React.SetStateAction<string>>,
    nome_medida: string
}
export function validarForm(campos: typeValidar) {//NOSONAR
    let { cod_tipo_uso, setError_tipo_uso, cod_produto, setError_produto,
        cod_fertilizante, setError_fertilizante, cod_variedade_hibrido, setError_variedade_hibrido, dosagem,
        setError_dosagem, quantidade, setError_quantidade, cod_tecnologia, setError_tecnologia, area, setError_area,
        cod_medida, nome_medida, setError_unidade_medida } = campos;

    if (cod_tipo_uso === null) {
        setError_tipo_uso('Campo obrigatório!');
        setError_area('Campo obrigatório!');
        setError_dosagem('Campo obrigatório!');
        setError_quantidade('Campo obrigatório!');
        setError_unidade_medida('Campo obrigatório!');
        errorAlert('Preencha os campos obrigatórios!');
    }
    //PRODUTO
    if (cod_tipo_uso === 1 || cod_tipo_uso === 4) {
        let condicoes = [
            { campo: cod_tipo_uso, setError: setError_tipo_uso },
            { campo: cod_produto, setError: setError_produto },
            { campo: area, setError: setError_area },
            { campo: dosagem, setError: setError_dosagem },
            { campo: quantidade, setError: setError_quantidade },
            { campo: cod_medida, setError: setError_unidade_medida },
            { campo: nome_medida, setError: setError_unidade_medida },
        ];
        alert(nome_medida)
        for (const item_condicao of condicoes) {
            if (item_condicao.campo === null || item_condicao.campo === '') {
                item_condicao.setError('Campo obrigatório!')
            }
        }
        if (cod_tipo_uso === null || cod_produto === null || area === '') {
            errorAlert('Preencha os campos obrigatórios!');
        }
    }
    //FERTILIZANTE
    if (cod_tipo_uso === 3) {
        let condicoes = [
            { campo: cod_tipo_uso, setError: setError_tipo_uso },
            { campo: cod_fertilizante, setError: setError_fertilizante },
            { campo: area, setError: setError_area },
            { campo: dosagem, setError: setError_dosagem },
            { campo: quantidade, setError: setError_quantidade },
            { campo: cod_medida, setError: setError_unidade_medida }
        ];

        for (const item_condicao of condicoes) {
            if (item_condicao.campo === null || item_condicao.campo === '') {
                item_condicao.setError('Campo obrigatório!')
            }
        }

        if (cod_tipo_uso === null || cod_fertilizante === null || area === '') {
            errorAlert('Preencha os campos obrigatórios!');
        }
    }
    //VAERIEDADE/HIBRIDO
    if (cod_tipo_uso === 2) {
        let condicoes = [
            { campo: cod_tipo_uso, setError: setError_tipo_uso },
            { campo: cod_variedade_hibrido, setError: setError_variedade_hibrido },
            { campo: cod_tecnologia, setError: setError_tecnologia },
            { campo: area, setError: setError_area },
            { campo: dosagem, setError: setError_dosagem },
            { campo: quantidade, setError: setError_quantidade },
            { campo: cod_medida, setError: setError_unidade_medida }
        ];

        for (const item_condicao of condicoes) {
            if (item_condicao.campo === null || item_condicao.campo === '') {
                item_condicao.setError('Campo obrigatório!')
            }
        }

        if (cod_tipo_uso === null || cod_variedade_hibrido === null || cod_tecnologia === null || area === '') {
            errorAlert('Preencha os campos obrigatórios!');
        }
    }

};

export function listarTipoDeUso(apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return dummy_tipos_uso;
    }

    let cods_tipos_plane = (insumos_planejados ?? [])?.map(i => i.cod_tipo);
    let filtrar_planejados = (dummy_tipos_uso ?? []).filter(item => cods_tipos_plane?.includes(item?.cod))

    return filtrar_planejados ?? []
};

// export function listarTiposInsumo(apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {

//     if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
//         return dummy_tipos_de_insumos;
//     }

//     let qtd_produtos = insumos_planejados?.filter(item=>item.cod_produto!==null)?.length;
//     let qtd_fertilizantes = insumos_planejados?.filter(item=>item.cod_fertilizante!==null)?.length;
//     let qtd_variedades = insumos_planejados?.filter(item=>item.cod_variedade_hibrido!==null)?.length;

//     let tipos_insumos = (dummy_tipos_de_insumos??[]).map((item, index)=>{
//         return {
//             ...item,
//             qtd: index===0 ? qtd_produtos : (index=== 1 ? qtd_fertilizantes : qtd_variedades) //nosonar
//         }
//     })

//     return tipos_insumos.filter(i=>i.qtd > 0)
// };

export function listarProdutos(lista_produtos: Item__AtvProdutos[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_produtos;
    };

    let cods_produto = (insumos_planejados ?? [])?.map(i => i.cod_produto);
    let filtrar_planejados = lista_produtos.filter(item => cods_produto?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarFertilizantes(lista_fertilizantes: Item__AtvFertilizantes[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_fertilizantes;
    };

    let cods_ferti = (insumos_planejados ?? [])?.map(i => i.cod_fertilizante);
    let filtrar_planejados = lista_fertilizantes.filter(item => cods_ferti?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarAdjuvantes(lista_adjuvantes: Item__AtvAdjuvantes[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_adjuvantes;
    };

    let cods_adju = (insumos_planejados ?? [])?.map(i => i.cod_adjuvante);
    let filtrar_planejados = lista_adjuvantes.filter(item => cods_adju?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarCalcarios(lista_calcarios: Item__AtvCalcario[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_calcarios;
    };

    let cods_calcario = (insumos_planejados ?? [])?.map(i => i.cod_calcario);
    let filtrar_planejados = lista_calcarios.filter(item => cods_calcario?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarInoculantes(lista_inoculantes: Item__AtvInoculante[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {

    let estrutura_lista_inoculantes = (lista_inoculantes ?? []).map((item) => {
        let dose_bula = item.parametros_bioinsumo?.[0]?.doses_por_hectare
        return {
            ...item,
            dose_bula: Number(dose_bula)
        }
    })

    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return estrutura_lista_inoculantes;
    };

    let cods_calcario = (insumos_planejados ?? [])?.map(i => i.cod_calcario);
    let filtrar_planejados = estrutura_lista_inoculantes.filter(item => cods_calcario?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarBiologicos(lista_biologicos: Item__AtvInoculante[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_biologicos;
    };

    let cods_calcario = (insumos_planejados ?? [])?.map(i => i.cod_calcario);
    let filtrar_planejados = lista_biologicos.filter(item => cods_calcario?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarVariedadesEHibridos(lista_variedades: Item__AtvVariedadeHibrido[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_variedades;
    };

    let cods_varie = (insumos_planejados ?? [])?.map(i => i.cod_variedade_hibrido);
    let filtrar_planejados = lista_variedades.filter(item => cods_varie?.includes(item?.cod))

    return filtrar_planejados;
}
export function listarTecnologias(lista_tecnologias: typeTecnologia[], apenas_planejados: boolean, insumos_planejados: Item__Atividades__insumos[]) {
    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return lista_tecnologias;
    };

    let cods_tecnos = (insumos_planejados ?? [])?.map(i => i.cod_variedade_hibrido);
    let filtrar_planejados = lista_tecnologias.filter(item => cods_tecnos?.includes(item?.cod_tecnologia))

    return filtrar_planejados;
}

export function listarMedidas(
    lista_medidas: Item__UnidadeMedida[],
    cod_tipo_uso: number,
    estado: string //sólido | liquido
) {

    //semente (variedade/hibrido)
    if (cod_tipo_uso === 2) {
        return [
            { cod: 3, nome: "Kg/ha", cod_tipo: 2, tipo_nome: "Sólido" },
            { cod: 9, nome: "sementes/ha", cod_tipo: 2, tipo_nome: "Sólido" }
        ];
    }
    if (cod_tipo_uso === 8) {
        return [
            { cod: 12, nome: "Dose/ha", cod_tipo: 1, tipo_nome: "Líquido" },
        ];
    }


    return listarMedidas2(lista_medidas, false, [], estado) ?? []
}

export function listarMedidas2(
    lista_medidas: Item__UnidadeMedida[],
    apenas_planejados: boolean,
    insumos_planejados: Item__Atividades__insumos[],
    estado: string //sólido | liquido
) {

    let medidas_permitidas = ['mL/ha', 'L/ha', 'Kg/ha', 'g/ha'];
    let ordem = { 2: 1, 1: 2, 4: 3, 3: 4 };
    let estado_permitido: 'sólido' | 'liquido' = estado ? String(estado).toLowerCase() as 'sólido' | 'liquido' : null;
    let medidas_por_estado = estado ? lista_medidas.filter(it => String(it.tipo_nome).toLowerCase() === estado_permitido) : lista_medidas;

    let lista_medidas_permitidas = (medidas_por_estado ?? []).filter(i => medidas_permitidas.includes(i.nome)).map((item) => {
        return {
            ...item,
            nome: renameUnidade(item.nome),
            ordem: ordem[item?.cod],
            nome_original: item.nome
        }
    });

    if (!apenas_planejados || insumos_planejados?.length === 0 || !insumos_planejados) {
        return orderBy(lista_medidas_permitidas, 'ordem', ['asc']);
    };

    let cods_medidas = (insumos_planejados ?? [])?.map(i => i.cod_medida);
    let filtrar_planejados = lista_medidas_permitidas.filter(item => cods_medidas?.includes(item?.cod));

    return orderBy(filtrar_planejados, 'ordem', ['asc']);
};


export function renameUnidade(nome_unidade: string, ignore_semente?: boolean) {

    if (ignore_semente && nome_unidade === 'sementes/ha') return nome_unidade;

    switch (String(nome_unidade)?.toLowerCase()) {
        case 'l/ha':
            return 'L';
        case 'ml/ha':
            return 'ml';
        case 'kg/ha':
            return 'kg';
        case 'g/ha':
            return 'g';
        case 'sc/ha':
            return 'sc';
        case 't/ha':
            return 't';
        case '@/ha':
            return '@';
        case 'dose/ha':
            return 'Dose';
        case 'sementes/ha':
            return 'de sementes';

        default:
            return nome_unidade
    }
};

export function calcularQuantidadePelaDose(dosagem: string, area_talhao_selecionado: number, porcentagem_remonte: string | number): string {

    let valor_DOSE = Number(String(dosagem)?.replace(',', "."));
    let valor_AREA = Number(area_talhao_selecionado);
    let valor_REMONTE = Number(porcentagem_remonte);

    if (valor_DOSE > 0) {

        let area_remonte = valor_REMONTE > 0 ? (valor_AREA * valor_REMONTE / 100).toFixed(2) : 0;
        let quantidade: number = Number(valor_DOSE) * (valor_AREA + Number(area_remonte));
        return String((quantidade)?.toFixed(2));
    }

    if (valor_DOSE <= 0) {
        return '?';
    }
};

export function calcularDosePelaQuantidade(quantidade: string, area_talhao_selecionado: number, porcentagem_remonte: string | number): string {

    const valor_AREA = Number(area_talhao_selecionado);
    const valor_REMONTE = Number(porcentagem_remonte);
    const valor_QUANTIDADE = Number(quantidade?.replace(",", '.'));

    if (valor_QUANTIDADE > 0) {

        let area_remonte = valor_REMONTE > 0 ? (valor_AREA * valor_REMONTE / 100) : 0;
        const dose = valor_QUANTIDADE / (Number(valor_AREA) + Number(area_remonte));

        return String((dose)?.toFixed(2));
    }

    if (valor_QUANTIDADE <= 0) {
        return '';
    }


}

/**usado para extrair valor calculo_dosagem de inoculante */
export function extrairNumeroAposAsterisco(str: string) {
    const match = String(str)?.match(/\*(\d+)/);
    return match ? Number(match[1]) : null;
}

/**usado para extrair medida do calculo_dosagem de inoculante */
export function extrairUnidade(str: string) {
    const match = String(str).match(/\*\d+([a-zA-Z]+)/);
    return match ? match[1] : null;
}

/**remove a string `/dose` e retorna apenas a unidade de medida: 
 * 
 * exemplo: `mL/dose => ml`
 */
export function removerDose(str: string) {
    return String(str)?.replace("/dose", "")?.replace("/Dose", "");
}